module.exports = __webpack_public_path__ + "static/img/SS_H5.f58381e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/SS_H5.png
// module id = AoAA
// module chunks = 34